<h2 mat-dialog-title class="mat-dialog-title" id="mit-forbrug-send-fejl-dialog-title">Min graf ser forkert ud</h2>
<mat-dialog-content id="mit-forbrug-send-fejl-dialog-form" [formGroup]="formGroup">
    <mat-form-field>
        <mat-label>Fejlbeskrivelse</mat-label>
        <textarea matInput formControlName="beskrivelse" cdkTextareaAutosize cdkAutosizeMinRows="3"></textarea>
        @if (formGroup.get('beskrivelse').errors) {
        <mat-error> Indtast en beskrivelse af problemet </mat-error>
        }
    </mat-form-field>
    <mat-form-field>
        <mat-label>Min mailadresse</mat-label>
        <input matInput formControlName="email" />
        @if (formGroup.get('email').errors) {
        <mat-error> Indtast en gyldig e-mail </mat-error>
        }
    </mat-form-field>
    <mat-form-field>
        <mat-label>Mit telefonnummer</mat-label>
        <input matInput formControlName="telefon" />
        @if (formGroup.get('telefon').errors) {
        <mat-error> Indtast et gyldigt telefonnummer </mat-error>
        }
    </mat-form-field>
    <mat-checkbox formControlName="accepter"
        >Jeg accepterer, at udvikleren af denne app anvender mine loginoplysninger til opslag og fejlsøgning. Udvikleren må desuden kontakte mig vedrørende denne henvendelse.</mat-checkbox
    >
    @if (formGroup.get('accepter').errors && formGroup.get('accepter').touched) {
    <mat-error> Du bedes acceptere betingelserne for at kunne indsende fejlbeskrivelse </mat-error>
    }
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="null" type="button" role="button">Annuller</button>
    <button mat-flat-button color="primary" (click)="onSend()" type="submit" role="button" [disabled]="!formGroup.valid" [attr.aria-disabled]="!formGroup.valid">Send</button>
</mat-dialog-actions>
